// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import MapFields, {
  useMapFields,
} from '../../../../components/MapFields/MapFields';
import { fieldsToImport, ProgressIndicator, useLink } from './_config';

export default function MapFieldsPage({ match }) {
  const link = useLink('mapFields');
  const history = useHistory();
  const props = useMapFields({
    workspaceId: match.params.workspaceId,
    importId: match.params.importId,
    fieldsToImport,
    importType: 'partnerAliasImport',
  });

  return (
    <Layout>
      <ProgressIndicator step="mapData" />
      <PageHeader>
        <PageTitle>
          <Trans>Map field names</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>
            Indicate which column contains information for the master list.
          </Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <MapFields {...props} />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton
          onClick={async () => {
            const result = await props.updateColumnsMapping();
            if (!result?.error) history.push(link.next());
          }}
          disabled={!props.isValid}
        />
      </Footer>
    </Layout>
  );
}
